var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.params.message)?_c('b-notification',{attrs:{"type":"is-warning","closable":false}},[_vm._v("\n    "+_vm._s(_vm.$route.params.message)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }